import styles from 'css/src/components/pricing/PricingPlanBlock.module.scss';

import React from 'react';
import classNames from 'classnames';

import type { Plan } from 'js/src/client';
import PricingPlanHighlights from 'js/src/components/pricing/PricingPlanHighlights';
import PricingPlanInfo from 'js/src/components/pricing/PricingPlanInfo';
import type { PlanSwitchErrorInfo } from 'js/src/components/pricing/types';

const PricingPlanBlock = React.memo(function PricingPlanBlock({
    plan,
    switchToPlan,
    saleSubHeading,
    planSubHeading,
    handlePlanSwitchError,
    andMoreClicked,
}: {
    plan?: Plan;
    switchToPlan: (plan: Plan, with_trial: boolean) => void;
    saleSubHeading?: string;
    planSubHeading?: string;
    handlePlanSwitchError: (error_info: PlanSwitchErrorInfo) => void;
    andMoreClicked: (e: React.MouseEvent) => void;
}) {
    // the community plan is horizontally layed out on the page
    const horizontalLayout = plan?.price === 0;

    return (
        <div
            className={classNames(styles['price-block'], 'd-flex', {
                featured: plan?.featured,
                current: SERVER.USER && SERVER.USER.plan === plan?.name,
                [styles['enterprise']]: plan?.is_enterprise,
                [styles['horizontal-layout']]: horizontalLayout,
            })}
        >
            <PricingPlanInfo
                plan={plan}
                switchToPlan={switchToPlan}
                saleSubHeading={saleSubHeading}
                planSubHeading={planSubHeading}
                handlePlanSwitchError={handlePlanSwitchError}
            />
            {!horizontalLayout && <hr className="my-l5-24" />}
            <PricingPlanHighlights
                highlights={plan?.highlights}
                showAndMore={plan?.price !== 0}
                andMoreClicked={andMoreClicked}
                className=""
            />
        </div>
    );
});

export default PricingPlanBlock;
